import React, { useEffect, useState } from 'react';

import ibsStore from '../Stores/IbsSurveyStore';
import { formatDate } from '../../helpers';
import { isLGPS } from '../../ibsHelper';
import { getScrapedData, updateTemplate } from '../../Services/IBS/IbsService';
import DropdownSearch from './DropdownSearch';
import { StatusID } from './InProcessMandateStatus';

import { AddModal } from './Modals/AddModal';
import { RemoveModal } from './Modals/RemoveModal';
import { LinkModal } from './Modals/LinkModal';
import { NotesModal } from './Modals/NotesModal';

const InProcessMandateRow = (props) => {
    const {
        agrId,
        analystComments,
        asset,
        assetClassId,
        dateAdded,
        filePath,
        fundName,
        isLgpsPoolOption,
        managerName,
        mandateId,
        newRow,
        rowId,
        statsInfo,
        status,
        statusId,
        style,
        styleId,
        templateType,
        isSelected,
        setCheckedRows,
        downloadFile,
        updateRow,
        managerId,
        normalizedManagerName,
    } = props;

    const inProcessRow = ibsStore.templateInProcess.find(inProcessRow => inProcessRow.rowId === rowId) || {};

    const rowData = {
        agrId,
        analystComments,
        asset,
        assetClassId,
        dateAdded,
        filePath,
        fundName,
        isLgpsPoolOption,
        managerName,
        mandateId,
        newRow,
        rowId,
        statsInfo,
        status,
        statusId,
        style,
        styleId,
        templateType,
        isSelected,
        setCheckedRows,
        downloadFile,
        updateRow,
        managerId,
        normalizedManagerName,
        ...inProcessRow
    };

    const [rowValues, _setRowValues] = useState({
        rowId: rowId,
        agrId: agrId,
        assetClassId: assetClassId,
        styleId: styleId,
        managerId: managerId,
        isLgpsPoolOption: isLgpsPoolOption,
        managerName: managerName ? managerName : '',
        fundName: fundName ? fundName : '',
    });

    useEffect(() => {
        setRowValues(prevValues => ({
            ...prevValues,
            rowId,
            agrId,
            assetClassId,
            styleId,
            isLgpsPoolOption,
            managerName: managerName || '',
            fundName: fundName || ''
        }));
    }, [rowId, agrId, assetClassId, styleId, isLgpsPoolOption, managerName, fundName]);    

    let { templateDropdownData, templateNormalizedManagerDropdownData } = ibsStore;

    const rawData = templateDropdownData.slice();

    const [addModalShow, setAddModalShow] = useState(false);
    const [removeModalShow, setRemoveModalShow] = useState(false);
    const [linkModalShow, setLinkModalShow] = useState(false);
    const [notesModalShow, setNotesModalShow] = useState(false);
    const [showHighlightNew, setShowHighlightNew] = useState(false);

    let classArr = ['actionRow'];

    const setRowValues = (updatedRow) => {
        _setRowValues(updatedRow);
        updateRow(updatedRow);
    };

    const setManagerName = (newManagerName, save = false) => {
        if (save && managerName !== newManagerName) {
            updateTemplate({ ...rowData, ...rowValues, inProcess: true, managerName: newManagerName });
        }
        _setRowValues({ ...rowValues, managerName: newManagerName });
    };

    const setFundName = (newFundName, save = false) => {
        if (save && fundName !== newFundName) {
            updateTemplate({ ...rowData, ...rowValues, inProcess: true, fundName: newFundName });
        }
        _setRowValues({ ...rowValues, fundName: newFundName });
    };

    const clickHandler = (e, className, rowData) => {
        setCheckedRows(rowData);
    };

    const changeAgrId = (e) => {
        /* Set asset, update style dropdown and set it */
        let selected = rawData.find(agrObj => agrObj.agrId === e);
        if (selected) {
            let updatedRow = {
                ...rowValues,
                agrId: e,
                assetClassId: selected.assetInfo.assetId,
                styleId: selected.styleInfo.styleId
            };
            setRowValues(updatedRow);
            updateTemplate({ ...rowData, inProcess: true, ...rowValues, agrId: e, assetClassId: selected.assetInfo.assetId, styleId: selected.styleInfo.styleId })
        }
    };

    const changeAsset = (e) => {
        /* Check style, if valid combo then set AgrId */
        /* else unset AgrId and Style, update Style dropdown */
        if (e !== null) {
            let newAssetClassId = parseInt(e);
            if (newAssetClassId) {
                if (rowValues.styleId !== 99) {
                    let chosenAgrObj = templateDropdownData.find(agrObj => agrObj.assetInfo.assetId === newAssetClassId && agrObj.styleInfo.styleId === rowValues.styleId);
                    if (chosenAgrObj) {
                        setRowValues({
                            ...rowValues,
                            agrId: chosenAgrObj.agrId,
                            assetClassId: newAssetClassId
                        });
                        updateTemplate({ ...rowData, ...rowValues, inProcess: true, agrId: chosenAgrObj.agrId, assetClassId: newAssetClassId });
                    } else {
                        setRowValues({
                            ...rowValues,
                            assetClassId: newAssetClassId,
                            agrId: "Unknown",
                            styleId: 99
                        });
                    }
                } else {
                    setRowValues({
                        ...rowValues,
                        agrId: "Unknown",
                        assetClassId: newAssetClassId
                    });
                }
            }
        }
    };

    const changeManager = (e) => {
        if (e !== null) {
            let newManagerId = parseInt(e);
            if (rowValues.managerId !== newManagerId) {
                setRowValues({ ...rowValues, managerId: newManagerId });
                updateTemplate({ ...rowData, ...rowValues, inProcess: true, managerId: newManagerId });
            }
        }
    };

    const changeStyle = (e) => {
        if (e !== null) {
            let newStyleId = parseInt(e);
            /* Check style, if valid combo then set AgrId */
            /* Else unset other two */
            if (rowValues.assetClassId !== 999) {
                let chosenAgrObj = templateDropdownData.find(agrObj => agrObj.assetInfo.assetId === rowValues.assetClassId && agrObj.styleInfo.styleId === newStyleId);
                if (chosenAgrObj) {
                    setRowValues({
                        ...rowValues,
                        agrId: chosenAgrObj.agrId,
                        styleId: newStyleId
                    });
                    updateTemplate({ ...rowData, ...rowValues, inProcess: true, agrId: chosenAgrObj.agrId, styleId: newStyleId });
                } else {
                    setRowValues({
                        ...rowValues,
                        styleId: newStyleId,
                        agrId: "Unknown"
                    });
                }
            } else {
                setRowValues({ ...rowValues, styleId: newStyleId });
            }
        }
    };

    /* Retrieve agrIDs, assets, and styles, generate all valid combinations */ 
    /* Make dropdowns searchable with event listeners for updates */
    const getManagers = () => {
        let managersData = templateNormalizedManagerDropdownData.slice();
        return managersData.map(datum => ({ managerId: datum.managerId ?? -1, managerName: datum.managerName })).reduce((prev, cur) => {
            if (!prev.find(managerData => managerData.managerId === cur.managerId)) {
                prev.push(cur);
            }
            return prev;
        }, []);
    };

    const getAssets = () => {
        return rawData.map(datum => ({ id: datum.assetInfo.assetId, name: datum.assetInfo.assetName })).reduce((prev, cur) => {
            if (!prev.find(assetObj => assetObj.id === cur.id)) {
                prev.push(cur);
            }
            return prev;
        }, []);
    };

    const getStyles = () => {
        let stylesObj = rawData.map(datum => datum.styleInfo).reduce((prev, cur) => {
            if (!prev[cur.styleId]) {
                prev[cur.styleId] = cur.styleName;
            }
            return prev;
        }, {});
        let styles = Object.entries(stylesObj).map(styleObj => {
            return { 'id': styleObj[0], 'name': styleObj[1] };
        });
        if (rowValues.assetClassId !== 999) {
            styles = templateDropdownData.filter(datum => datum.assetInfo.assetId === rowValues.assetClassId).map(agrObj => ({ id: agrObj.styleInfo.styleId, name: agrObj.styleInfo.styleName }));
            styles.push({ 'id': 99, 'name': "Unknown" });
        }
        return styles;
    };

    const getAgrIds = () => {
        return rawData.map(datum => datum.agrId);
    };

    const renderModals = () => (
        <section className="generalModal">
            <AddModal addModalShow={addModalShow} setAddModalShow={setAddModalShow} row={rowData} />
            <RemoveModal removeModalShow={removeModalShow} setRemoveModalShow={setRemoveModalShow} row={rowData} />
            <LinkModal linkModalShow={linkModalShow} setLinkModalShow={setLinkModalShow} row={rowData} updateRow={updateRow} />
            <NotesModal notesModalShow={notesModalShow} setNotesModalShow={setNotesModalShow} row={rowData} inProcess={true} updateRow={updateRow} />
        </section>
    );

    const renderStatusText = () => {
        let splitStatus = status.split('\n');
        return splitStatus.map((l, i) => (
            <React.Fragment key={i}>{l}{i < (splitStatus.length - 1) ? <br /> : ''}</React.Fragment>
        ));
    };

    let managers = getManagers();
    let assets = getAssets();
    let styles = getStyles();
    let agrIDs = getAgrIds();
    let modals = renderModals();
    let statusText = renderStatusText();

    if (isSelected) {
        classArr.push('highlightBlue');
    }

    if (newRow && showHighlightNew) {
        setTimeout(() => {
            setShowHighlightNew(false);
        }, 5000);
    }

    if (statusId === StatusID.FAILED) {
        return (
            <tr className={classArr.join(' ') + (showHighlightNew ? ' highlightGreen' : newRow ? ' fadeOutRow' : '')}>
                <td>{mandateId === 0 ? 'NA' : mandateId}</td>
                <td className='searchable agrId'></td>
                <td className='searchable asset'></td>
                <td className='searchable style'></td>
                <td>{rowValues.normalizedManagerName}</td>
                <td>{rowValues.managerName}</td>
                <td>{rowValues.fundName}</td>
                <td></td>
                {isLGPS() ? <td></td> : null}
                <td>{statsInfo}</td>
                <td>{templateType}</td>
                <td className="uploadLinkTd">
                    <div
                        title={filePath ? filePath.substring(Math.max(filePath.lastIndexOf("\\") + 1, 0)) : ""}
                        onClick={() => downloadFile(rowData, true)}
                        className={'downloadLink' + (filePath === 'broken' ? ' broken' : '')}
                    >
                        {filePath ? 'Get file' : ''}
                    </div>
                </td>
                <td>{formatDate(dateAdded)}</td>
                {analystComments ? (
                    <td
                        className='hoverCell'
                        onClick={() => setNotesModalShow(true, { ...rowData, agrId: rowValues.agrId, style: rowValues.styleId, asset: rowValues.assetClassId }, true)}
                    >
                        <i className="fas fa-sticky-note"></i>
                    </td>
                ) : (
                    <td
                        className='hoverCell'
                        onClick={() => setNotesModalShow(true, { ...rowData, agrId: rowValues.agrId, style: rowValues.styleId, asset: rowValues.assetClassId }, true)}
                    >
                        <i className="far fa-sticky-note"></i>
                    </td>
                )}
                <td>{statusText}</td>
                <td>
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onClick={(e) => clickHandler(e, 'highlightBlue', rowData)}
                    />
                    {modals}
                </td>
            </tr>
        );
    } else {
        const isEditable = statusId === StatusID.NEW || statusId === StatusID.FAILED;

        return (
            <tr className={classArr.join(' ') + (showHighlightNew ? ' highlightGreen' : newRow ? ' fadeOutRow' : '')}>
            <td>
                {isEditable ? (
                    <a onClick={() => setLinkModalShow(true, { ...rowData, agrId: rowValues.agrId, styleId: rowValues.styleId, assetId: rowValues.assetClassId })}>
                        {mandateId === 0 ? "Link" : mandateId}
                    </a>
                ) : (mandateId === 0 ? 'NA' : mandateId)}
            </td>
            <td className='searchable agrId'>
                {isEditable ? (
                    <DropdownSearch 
                        changeHandler={changeAgrId} 
                        curValue={rowValues.agrId} 
                        options={agrIDs.map(agrName => ({ value: agrName, name: agrName }))} 
                    />
                ) : agrId}
            </td>
            <td className='searchable asset'>
                {isEditable ? (
                    <DropdownSearch 
                        changeHandler={changeAsset} 
                        curValue={rowValues.assetClassId} 
                        options={assets.map(assetObj => ({ value: assetObj.id, name: assetObj.name }))} 
                    />
                ) : assetClassId}
            </td>
            <td className='searchable style'>
                {isEditable ? (
                    <DropdownSearch 
                        changeHandler={changeStyle} 
                        curValue={rowValues.styleId} 
                        options={styles.map(styleObj => ({ value: styleObj.id, name: styleObj.name }))} 
                    />
                ) : styleId}
            </td>
            <td className='searchable manager'>
                {isEditable ? (
                    <DropdownSearch 
                        changeHandler={changeManager} 
                        curValue={rowValues.managerId} 
                        options={managers.map(manager => ({ value: manager.managerId, name: manager.managerName }))} 
                    />
                ) : managerId}
            </td>
            <td>
                {isEditable ? (
                    <input 
                        type="text" 
                        className="uploadTextBox" 
                        value={rowValues.managerName} 
                        title={rowValues.managerName} 
                        onChange={(e) => setManagerName(e.target.value)} 
                        onBlur={(e) => setManagerName(e.target.value, true)} 
                    />
                ) : rowValues.managerName}
            </td>
            <td>
                {isEditable ? (
                    <input
                        type="text" 
                        className="uploadTextBox" 
                        value={rowValues.fundName} 
                        title={rowValues.fundName} 
                        onChange={(e) => setFundName(e.target.value)} 
                        onBlur={(e) => setFundName(e.target.value, true)} 
                    />
                ) : rowValues.fundName}</td>
            {isLGPS() ? (
                <td>
                    {isEditable ? (
                        <input 
                            type="checkbox" 
                            className="uploadCheckBox" 
                            checked={rowValues.isLgpsPoolOption} 
                            onClick={(e) => {
                                setRowValues({
                                    ...rowValues,
                                    isLgpsPoolOption: !rowValues.isLgpsPoolOption
                                });
                                updateTemplate({ ...rowData, ...rowValues, inProcess: true, isLgpsPoolOption: !rowValues.isLgpsPoolOption });
                            }} 
                        /> 
                    ): rowValues.isLgpsPoolOption ? 'Yes' : ''}
                </td>
                ) : null}
            <td>
                <a onClick={async () => {
                    let tableHtml = await getScrapedData(rowId);

                    var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=780");
                    win.document.body.innerHTML = tableHtml;
                }}>{statsInfo}</a>
            </td>
            <td>{templateType}</td>
            <td className="uploadLinkTd">
                <div 
                    title={filePath ? filePath.substring(Math.max(filePath.lastIndexOf("\\") + 1, 0)) : ""} 
                    onClick={() => downloadFile(rowData, true)} 
                    className={'downloadLink' + (filePath === 'broken' ? ' broken' : '')}
                >
                    {filePath ? 'Get file' : ''}
                </div>
            </td>
            <td>{formatDate(dateAdded)}</td>
            {analystComments ? (
                <td 
                    className='hoverCell' 
                    onClick={() => setNotesModalShow(true, { ...rowData, agrId: rowValues.agrId, style: rowValues.styleId, asset: rowValues.assetClassId }, true)}
                >
                    <i className="fas fa-sticky-note"></i>
                </td>
            ) : (
                <td 
                    className='hoverCell' 
                    onClick={() => setNotesModalShow(true, { ...rowData, agrId: rowValues.agrId, style: rowValues.styleId, asset: rowValues.assetClassId }, true)}
                >
                    <i className="far fa-sticky-note"></i>
                </td>
                )}
            <td>{statusText}</td>
            <td></td>
            <td>
                <input 
                    type="checkbox" 
                    checked={isSelected} 
                    onClick={(e) => clickHandler(e, 'highlightBlue', rowData)} 
                />
                {modals}
            </td>
        </tr>)
    }
};

export default React.memo(InProcessMandateRow, areEqual);

function areEqual(prevProps, nextProps) {
    let propsToCheck = ['agrId', 'analystComments', 'asset', 'assetClassId', 'dateAdded', 'filePath', 'fundName', 'isLgpsPoolOption', 'managerName', 'mandateId', 'rowId', 'statsInfo', 'status', 'statusId', 'style', 'styleId', 'isSelected'];

    for (let idx = 0; idx < propsToCheck.length; idx++) {
        const propId = propsToCheck[idx];
        if (prevProps[propId] !== nextProps[propId]) {
            return false;
        }    
    }

    return true;
}